var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-row',[_c('v-col',[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }